export default "__VITE_PUBLIC_ASSET__0fc081f5__"